import { FunctionComponent } from "react";
import { Heading } from "../Text/Heading";

export interface IconOptionBoxProps {
  id: string;
  index: number;
  questionId: string;
  icon: string;
  heading: string;
  description: string;
  label?: string;
  value?: number;
  note?: string;
  list?: { id: string; ref: string }[];
  isSelected?: boolean;
  onSelect: Function;
  disabled: boolean;
  answers: any;
}

const IconOptionBox: FunctionComponent<IconOptionBoxProps> = ({
  heading,
  description,
  icon,
  label,
  value,
  note,
  isSelected,
  onSelect,
  disabled,
  list,
  answers,
}) => {
  const refObj = list?.find((el) => el.id === "laufzeit");
  let laufzeit: number | null = null;

  if (refObj?.ref) {
    const answer = answers[refObj.ref];
    if (answer?.data) {
      let stringArray = [];
      if (answer.type === "input") {
        stringArray = Object.values(answer.data).map(
          (el: any) => el?.value || "––"
        );
      } else {
        stringArray = Object.values(answer.data).map(
          (el: any) => el?.label || "––"
        );
      }
      laufzeit = parseInt(stringArray.join(", "));
    }
  }
  console.log("REFOBJ", refObj, list);
  laufzeit && console.log("LAUFZEIT", laufzeit);
  console.log("VALUE", value);
  let calculatedlabel;
  let calculatedValue: number;
  if (laufzeit && laufzeit !== 24 && value && label) {
    calculatedValue = (value * 12) / laufzeit;
    console.log(label, value.toFixed(2).replace(".", ","));
    calculatedlabel = label?.replace(
      value.toFixed(2).replace(".", ","),
      calculatedValue.toFixed(2).replace(".", ",")
    );
  }
  return (
    <div
      className={`flex flex-col relative justify-between py-10 px-8 border-gray-300 items-start border rounded-multiple-choice lg:max-w-xxs w-full text-left h-full ${
        disabled ? "cursor-default" : "cursor-pointer"
      } ${isSelected ? "border-primary bg-primary-light" : ""}`}
      onClick={() => onSelect(calculatedValue)}
    >
      {disabled ? (
        <div className="absolute top-0 bottom-0 right-0 left-0 bg-gray-200 opacity-75 z-50 p-2">
          <p className="text-center font-semibold">Aktuell nicht verfügbar</p>
        </div>
      ) : null}
      <div>
        <img src={icon} height="48px" width="48px" className="mb-4" />
        <Heading level={5} className="mb-2">
          {heading}
        </Heading>
        <p className="text-sm">{description}</p>
      </div>
      {(label || note) && (
        <p className="text-2xl text-primary font-bold mt-6">
          {calculatedlabel ?? label}{" "}
          <span className="text-base font-normal text-gray-500">{note}</span>
        </p>
      )}
    </div>
  );
};

export default IconOptionBox;
